exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".properties__optionslist[data-v-36bee325]{margin-bottom:5px;list-style:none;list-style-type:none}.properties__optionsul[data-v-36bee325]{padding:0}", ""]);

// exports
